var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1934 38.8902C12.1934 38.244 12.635 37.7202 13.1797 37.7202H22.3361C22.8808 37.7202 23.3224 38.244 23.3224 38.8902C23.3224 39.5363 22.8808 40.0601 22.3361 40.0601H13.1797C12.635 40.0601 12.1934 39.5363 12.1934 38.8902Z",
    fill: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12158 29.7784H51.8806V23.566H8.12158V29.7784Z",
    fill: "#0E5CF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8104 18.925C9.94201 18.925 9.24103 19.5947 9.24103 20.4169V41.16C9.24103 41.9822 9.94201 42.6519 10.8104 42.6519H49.1896C50.058 42.6519 50.759 41.9822 50.759 41.16V20.4169C50.759 19.5947 50.058 18.925 49.1896 18.925H10.8104ZM7 20.4169C7 18.4114 8.70786 16.7885 10.8104 16.7885H49.1896C51.2921 16.7885 53 18.4114 53 20.4169V41.16C53 43.1655 51.2921 44.7885 49.1896 44.7885H10.8104C8.70786 44.7885 7 43.1655 7 41.16V20.4169Z",
    fill: "#0E5CF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredTransaction);
export default __webpack_public_path__ + "static/media/ic-colored-transaction.f1816c2ea99edc860e6c54feca9b0632.svg";
export { ForwardRef as ReactComponent };